import baseurl from "./baseurl.js";

//请求的接口配置
// const base = {
//     indexMenu: baseurl + '/api/index/indexInfo', //首页
//     aboutList: baseurl + '/api/index/getAboutInfo', //合作伙伴
//     indexList: baseurl + "/api/index/indexInfo",//首页数据
//     getCategoryInfo: baseurl + "/api/index/getCategoryInfo",//新闻列表接口数据
//     getProductInfo: baseurl + "/api/index/getProductInfo",//解决方案详情
//     getNewInfo: baseurl + "/api/index/getNewInfo?nid=1",//新闻详情
//     message: baseurl + "/api/index/userAddMessage",//留言

// }

const base = {
    indexMenu: '/api/api/index/indexInfo', //首页
    aboutList: '/api/api/index/getAboutInfo', //合作伙伴
    indexList: "/api/api/index/indexInfo",//首页数据
    getCategoryInfo: "/api/api/index/getCategoryInfo",//新闻列表接口数据
    getProductInfo: "/api/api/index/getProductInfo",//解决方案详情
    getNewInfo: "/api/api/index/getNewInfo?nid=1",//新闻详情
    message: "/api/api/index/userAddMessage",//留言
    register:"/api/api/shoplogin/register",//注册
    login: "/api/api/shoplogin/login",//登录
    getShopProductList: "/api/api/shop/getShopProductList",//商品列表

    shopList: '/api/api/shop/getShopProductList', //商城商品
    getQrcode:'/api/api/weixinpay/getQrcode'//微信支付
}

export default base
export  const codeImg="/api/api/shoplogin/getCode"//获取验证